import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from 'vuex-persistedstate'
import state from './state'
// import mutations from './mutations'
import clients from './clients.module'

Vue.use(Vuex)

export default new Vuex.Store({
   state, 
   // mutations, 
   modules: {
      clients
   },
   plugins: [createPersistedState()]
})


// WEBPACK FOOTER //
// ./src/js/store/store.js